import { takeEvery } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';

import * as actions from './accountsValueChangesActions';
import { mkAccountsValueChanges } from './accountsValueChangesTypes';

const mkResourceConfig = (successAction, failureAction) =>
  resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'accounts-value-changes',
    resourceBaseUrl: '/reports/accounts/value-changes',
    successAction,
    failureAction,
    transformResponseToResources: (response) =>
      response.data && response.data.resources && response.data.resources.map((data) => mkAccountsValueChanges(data)),
  });

export function* getAccountsValueChangesActionWatcher() {
  const resourceConfig = mkResourceConfig(
    actions.getAccountsValueChangesSuccess,
    actions.getAccountsValueChangesFailure,
  );
  // TODO: add reportsSagaUtils and genericSagaUtils
  yield takeEvery(actions.getAccountsValueChanges, resourceSagaUtils.qcsSyncGetResources, resourceConfig);
}

export default [getAccountsValueChangesActionWatcher];
